export enum NominationModules {
  SUPERVISORS = 'supervisors',
  CHIEF_SUPERVISOR = 'chiefSupervisor',
  SUPERVISOR_TEAM = 'supervisorTeam',
  FORM = 'gsb1Form',

  SCHOLARSHIP_NOMINATION = 'scholarshipNomination',
  FUNDINGS = 'fundings',

  EVALUATION = 'evaluation',

  DECLARATION = 'declaration',
  REMARKS = 'remarks',
}
